import StatsCardGreenpill from '../../ui/StatsCardGreenpill';
import TrophyIcon from '../../assets/icons/TrophyIcon';
import { useNavigate } from 'react-router-dom';
import Achievment from './Achievment';
import SelectPrimaryPill from './SelectPrimaryPill';
import Modal from '../../ui/Modal';

import MintNFTModal from './MintNFTModal';
import ButtonGreen from './ButtonGreen';
import { formatNumber } from '../../helpers/formatNumber';

import { useImpacts } from '../../hooks/useImpacts';

const UpperLeftGreenpillSection = () => {
    const navigate = useNavigate();
    const [yourImpacts] = useImpacts();

    return (
        <div className="">
            <h1
                className="text-5xl font-semibold text-[white]"
                style={{
                    textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                }}
            >
                {'Greenpill  Collection'}
            </h1>
            <p className="text-[#CFCFCF] text-sm mt-2 ">
                Greenpill Collection The Greenpill NFT Collection is a series of mutating NFTs that evolve & grow in
                value based on real world actions!
            </p>

            <div className="flex items-center mt-7  gap-3 mb-5">
                <div>
                    <Modal>
                        <Modal.Button opens={'mint'}>
                            <ButtonGreen w={'w-[10.5rem]'} name={'Mint  New NFT'} />
                        </Modal.Button>
                        <Modal.Window name={'mint'}>
                            <MintNFTModal />
                        </Modal.Window>
                    </Modal>
                </div>
                <SelectPrimaryPill />
            </div>

            <div className="flex items-center ">
                <div className=" flex  items-center gap-3 ">
                    <StatsCardGreenpill
                        label="IP unlocked"
                        symbol={<TrophyIcon />}
                        stats={formatNumber(yourImpacts[0]?.impactPoints?.toFixed(2) || 0)}
                        loading={false}
                    />
                    <StatsCardGreenpill label="Status" symbol={''} stats={'Yellow'} loading={false} />

                    <StatsCardGreenpill
                        label="My rank"
                        symbol={<p className="text-4xl font-medium ">#</p>}
                        stats={yourImpacts[0]?.impactRank || 0}
                        applyHover={true}
                        className={'w-40'}
                        onClick={() => navigate('/profile/leaderboard')}
                        loading={false}
                    />
                </div>
            </div>
            <Achievment />
        </div>
    );
};

export default UpperLeftGreenpillSection;
